<template>
  <div name="settings">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Settings</h2>

        <div>
          <button
            type="button"
            class="
              filter-bar-button
              text-gray-800
              hover:opacity-75
              focus:outline-none
            "
            @click="logout()"
          >
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </div>
      </div>
    </header>

    <div
      class="
        w-full
        px-8
        h-12
        mb-6
        bg-white
        border-b border-gray-200
        flex
        content-center
      "
    >

    <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >

      <span v-if="path.id === 7">{{   path.name }} <span class="text-xs text-blue-500">({{$version}})</span></span>
      <span v-else> {{ path.name }}</span>

       
      </button>
    </div>

    <router-view />

   

  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "settings",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    tabsList() {
      return this.tabs
    }
  },
  data() {
    return {
      tabs: [],
      selectedPath: {},
    };
  },
  created() {
   
  },
  mounted() {
    let companyTitle = this.currentUser.isSchool == false ? "Organisation Admin" : "School Admin"

    this.tabs = [
      {id: 2, name: "General", path: "configuration"},

    ]

   // if (!this.currentUser.isAdmin) {
      this.tabs.push({id: 3, name: "Teachers", path: "users"})
      this.tabs.push({id: 4, name: "Rooms", path: "rooms"})
      this.tabs.push({id: 5, name: "Classes", path: "classes"})
      this.tabs.push({id: 6, name: "Assessment", path: "assessment"})
    //}

    this.tabs.push({id: 7, name: "Support", path: "support"}) 

    this.selectedPath = this.tabs[0]
  },
  methods: {
    showPath(object) {
      if (this.selectedPath.id === object.id) { return }

      if (object.path === "support") {
        let url = "https://primarypepassport.co.uk/faqs/"
        window.open(url, '_blank', 'noreferrer');
        return
      } 

      
      this.selectedPath = object;
      this.$router.push("/settings/" + object.path);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
  components: {
    
  },
};
</script>

<style scoped>
</style>